import React from 'react';
import { faqs } from './FAQ';
const reviews = ['Marilyn really went out of her way to understand my needs and preferences and was with me all along to make it perfect with dozens of revisions. Very professional and looking to use her again and again!', 'She understood my vision and made it come to life. If you are in need of marketing templates or help with the aesthetic of an existing one, she is the right choice.', 'Marilyn literally saved the day for me! She helped me create and edit my presentation until it was perfect. I gave the best speech of my life and got a standing ovation. She went above and beyond.'];
export function StructuredData() {
  const data = {
    '@context': 'https://schema.org',
    '@graph': [{
      '@type': 'ProfessionalService',
      '@id': 'https://olicreative.com/#business',
      name: 'Oli Creative',
      description: 'Independent graphic design studio offering presentation design, brochures, website design, brand identity, business cards, marketing collateral, and email marketing.',
      email: 'marilyn.peixoto@gmail.com',
      founder: {
        '@type': 'Person',
        name: 'Mari Peixoto',
        jobTitle: 'Graphic Designer'
      },
      areaServed: 'Worldwide',
      address: {
        '@type': 'PostalAddress',
        addressRegion: 'California',
        addressCountry: 'US'
      },
      makesOffer: ['Presentation Design', 'Brochures & Print', 'Website Design', 'Brand Identity', 'Business Cards', 'Marketing Collateral', 'Email Marketing'].map(service => ({
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: service
        }
      })),
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        bestRating: '5',
        reviewCount: reviews.length
      },
      review: reviews.map(body => ({
        '@type': 'Review',
        reviewRating: {
          '@type': 'Rating',
          ratingValue: '5',
          bestRating: '5'
        },
        author: {
          '@type': 'Person',
          name: 'Upwork Client'
        },
        reviewBody: body
      }))
    }, {
      '@type': 'FAQPage',
      '@id': 'https://olicreative.com/#faq',
      mainEntity: faqs.map(faq => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer
        }
      }))
    }]
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{
    __html: JSON.stringify(data)
  }} data-id="element-176" />;
}